import { Card } from "../../components/Card";
import { Button } from "../../components/Button";
import { formatIrkutskLocalDateTime } from "../../lib/time";

export function PromotionsActionsList({
  loading,
  error,
  items,
  joinedRaffleIds,
  joiningRaffleId,
  onJoinRaffle,
}) {
  if (loading) {
    return <p className="muted">Загрузка акций…</p>;
  }
  if (error) {
    return <p className="errorMessage">{error}</p>;
  }
  return (
    <div className="eventsList">
      {items.length === 0 ? (
        <p className="muted">Сейчас нет активных акций.</p>
      ) : (
        items.map((action) => (
          <Card
            key={action.id}
            variant="light"
            title={action.kind === "raffle" ? `Розыгрыш: ${action.title}` : action.title}
            subtitle={
              action.kind === "raffle"
                ? `${action.description ?? ""}${
                    action.raffle_draw_at
                      ? `\n\nДата и время: ${formatIrkutskLocalDateTime(action.raffle_draw_at)}`
                      : ""
                  }${
                    Array.isArray(action.raffle_prizes) && action.raffle_prizes.length
                      ? `\nПризы: ${action.raffle_prizes
                          .map((x, i) =>
                            x?.is_bonus_points
                              ? `${i + 1} место — ${x?.bonus_amount || 0} баллов`
                              : `${i + 1} место — ${x?.title || "Приз"}`
                          )
                          .join("; ")}`
                      : ""
                  }`
                : action.description ?? ""
            }
          >
            {action.kind === "raffle" ? (
              <div className="promotionsPromoCard__form">
                {Boolean(action.raffle_drawn_at) ? (
                  <>
                    <p className="muted">
                      Розыгрыш завершён: {formatIrkutskLocalDateTime(action.raffle_drawn_at)}
                    </p>
                    {Array.isArray(action.raffle_winners) && action.raffle_winners.length > 0 ? (
                      <div>
                        <p className="muted">Победители и призы:</p>
                        <ul>
                          {action.raffle_winners.map((winner) => (
                            <li key={`${action.id}:${winner.place}:${winner.telegram_id}`}>
                              {winner.place} место —{" "}
                              {winner.full_name
                                ? `${winner.full_name} (ID ${winner.telegram_id})`
                                : `ID ${winner.telegram_id}`}
                              : {winner.prize}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <p className="muted">Победителей нет (никто не участвовал).</p>
                    )}
                  </>
                ) : (
                  <>
                    <p className="muted">Участников: {Number(action.raffle_participants_count || 0)}</p>
                    <Button
                      type="button"
                      variant="accent"
                      disabled={
                        joinedRaffleIds.includes(action.id) || joiningRaffleId === action.id
                      }
                      onClick={() => onJoinRaffle(action.id)}
                    >
                      {joinedRaffleIds.includes(action.id)
                        ? "Вы зарегистрированы"
                        : joiningRaffleId === action.id
                          ? "Регистрация..."
                          : "Участвовать в розыгрыше"}
                    </Button>
                  </>
                )}
              </div>
            ) : null}
          </Card>
        ))
      )}
    </div>
  );
}
